import BannersCommunity from './BannersCommunity'

export default BannersCommunity
export type { BannersCommunityProps } from './BannersCommunity'
